import { getNextPage, pageParams, retrieveFromStorage, saveToStorage } from "../../Components/Functions";
import Api from "../../Server/Api";
import { UPDATE, UPDATE_PARAMETERS } from "./types";

const api = new Api();

const _INITIAL_STORAGE_SEARCH_PARAMS = retrieveFromStorage(UPDATE_PARAMETERS)


export const updateSearchResults = (data = null) => {
	let page = getNextPage(data);
	return async (dispatch, getState) => {
		dispatch({ searching: true, type: UPDATE })
		const res = await api.post({ endpoint: `users/search${ page ? "/?page="+page : "/" }`, data: getState().searchParameters });
		const _pageData = pageParams(res);
		dispatch({ ...res, ..._pageData, searching: false, type: UPDATE });
	}
};

export const updateSearchParameters = (data = {}) => {
	var store = { ...data, type: UPDATE_PARAMETERS, searching: true };
	saveToStorage({ name: UPDATE_PARAMETERS, value: store });
	return async (dispatch) => {
		dispatch({ ...store });
		// if(window.location.pathname === "/search"){
		// 	dispatch(updateSearchResults())
		// }
	}
};
